import { WheelsListing } from '../wheels-listing';
import DropdownCombobox from '../../combobox/dropdown-combobox';
import ProductSelectorEmbed from './product-selector';


export default class ProductSelectorEmbedWheel extends WheelsListing {

  parent: ProductSelectorEmbed;

  /**
   * Wheel selector logic. Reuses wheels listing functionality.
   *
   * @param {HTMLElement} tabEl - Tab element containing the wheel selector
   */
  constructor(tabEl: HTMLElement, parent: ProductSelectorEmbed) {
    const wheelSelectorRoot = tabEl.querySelector('[data-wheel-selector]') as HTMLElement;
    super(wheelSelectorRoot);

    this.parent = parent;

    this.#initDropdowns();
    this.#initEmbedListeners();

    console.log('[ProductSelectorEmbedWheel]: init wheel module');
  }

  /**
   * Initialise custom dropdowns for native selects
   */
  #initDropdowns() {
    const domElements = this.getElements();

    ['productLine', 'machine', 'tyre', 'rimSize'].forEach(key => {
      const selectEl = domElements[key];
      if(selectEl) {
        new DropdownCombobox({
          select: selectEl,
          cssClassPrefix: 'combobox',
        });
      }
    });
  }

  /**
   * Initialise event listeners for the embed wheel selector
   */
  #initEmbedListeners() {
    const domElements = this.getElements();
    const form = domElements.filterForm;

    this.onFormSubmit = this.onFormSubmit.bind(this);
    form.addEventListener('submit', this.onFormSubmit);
  }

  /**
   * Handles form submit
   *
   * @param {Event} event  - Submit event
   */
  onFormSubmit(event) {
    event.preventDefault(); // Pause the form submit
    this.parent.setLoading(true);

    // Send analytics event
    this.#sendEvent('product_selector_submit', {
      product_type: 'Wheel',
      product_industry: this.values.productLine,
      product_machine: this.values.machine,
    });

    // Remove the event listener for form submit
    event.target.removeEventListener('submit', this.onFormSubmit);

    // Continue with the native form submit
    event.target.submit();
  }

  /**
   * Triggers events based on changed values.
   *
   * @param {TireSelectorValues} newValues Current values.
   * @param {TireSelectorValues} oldValues Old values.
   */
  triggerEvents(newValues, oldValues) {
    if (newValues.machine !== oldValues.machine) {
      this.#sendEvent('product_selector_embed_interaction', {
        product_type: 'Wheel',
        product_option: 'Machine',
        product_option_value: newValues.machine,
      });
    }
    if (newValues.productLine !== oldValues.productLine) {
      this.#sendEvent('product_selector_embed_interaction', {
        product_type: 'Wheel',
        product_option: 'Product line',
        product_option_value: newValues.productLine,
      });
    }
    if (newValues.tyre !== oldValues.tyre) {
      this.#sendEvent('product_selector_embed_interaction', {
        product_type: 'Wheel',
        product_option: 'Tire',
        product_option_value: newValues.tyre,
      });
    }
    if (newValues.rimSize !== oldValues.rimSize) {
      this.#sendEvent('product_selector_embed_interaction', {
        product_type: 'Wheel',
        product_option: 'Rim',
        product_option_value: newValues.rimSize,
      });
    }
  }

  /**
   * Send tire selector analytics event to datalayer.
   *
   * @param {string} name - Event name
   * @param {object} [data] - Optional event data
   */
  #sendEvent(name, data = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      ...data
    });
  }

  /**
   * @inheritdoc
   * @protected
   */
  showResults(products) {
    // Do nothing, because embed does not show products, instead form submits to wheels page with params
  }
}
